var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('div',{attrs:{"id":"logo"},on:{"click":function($event){return _vm.$parent.showpage('default')}}},[_c('inline-svg',{attrs:{"src":require('../assets/logotypemotion.svg')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }